import { render, staticRenderFns } from "./icon-arrow.vue?vue&type=template&id=0678a735&scoped=true&"
import script from "./icon-arrow.vue?vue&type=script&lang=js&"
export * from "./icon-arrow.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow.vue?vue&type=style&index=0&id=0678a735&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678a735",
  null
  
)

export default component.exports